import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { IConfirm } from './confirm.interface';
import { ConfirmService } from './confirm.service';
import {takeUntil} from 'rxjs/operators';


@Component({
  selector: 'pgs-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.scss']
})
export class ConfirmComponent implements OnInit, OnDestroy {

  @ViewChild('content', { static: true }) content: any;

  private ngUnsubscribe: Subject<void>;
  data: IConfirm;

  constructor(private modalService: NgbModal,
              private confirmService: ConfirmService) { }

  ngOnInit() {
    this.ngUnsubscribe = new Subject<void>();
    this.confirmService.data
    .pipe(takeUntil(this.ngUnsubscribe))
    .subscribe(
      data => {
        this.data = data;
        this.open();
      }
    );
  }

  ngOnDestroy(): void {
		if (this.ngUnsubscribe) {
			this.ngUnsubscribe.next();
			this.ngUnsubscribe.complete();
		}
	}

  open() {
    if (!this.content) {
      return;
    }

    this.modalService.open(this.content).result.then(
      (result) => this.data.result(result),
      (reason) => this.data.result(false)
    );
  }

}
